export const extractCompanyFromUrl = (url) => {
  if (!url) return ''

  const regex = /https?:\/\/([^.]+)(\.chat)?(\.new-staging|\.staging|\.dev)?\.proton\.ai.*/
  const companyInstance = url.match(regex)
  if (companyInstance && companyInstance.length > 1) {
    return companyInstance[1]
  }
  return ''
}

export const buildRedirectUrl = (company) => {
  if (!company) return '/'

  let url = window.location.host
  url = url.replace('janus', company)

  return window.location.protocol + '//' + url
}

export const checkPasswordStrength = (rule, value, callback) => {
  if (!value) {
    return callback()
  }

  const conditions = [
    { regex: /[A-Z]/, label: 'an uppercase letter' },
    { regex: /[a-z]/, label: 'a lowercase letter' },
    { regex: /\d/, label: 'a number' },
    { regex: /[!@#$%^&*()_+\-=\[\]{}|;:,.<>?]/, label: 'a special character' }
  ]

  const conditionsMet = conditions.filter(cond => cond.regex.test(value)).length

  if (conditionsMet < 3) {
    const requirementList = conditions.map(c => c.label).join(', ')
    return callback(new Error(`Password must meet at least 3 of these requirements: ${requirementList}`))
  }

  callback()
}